import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetRecord } from 'root/admin/components/hooks';
import { Column, Loader, Form, Field } from '@smartplatform/ui';
import { ModelTable } from '../../components';

const MediaList = ({ rootPath }) => {
	const { id } = useParams();
	const record = useGetRecord({
		model: 'MediaTitle',
		id,
		options: { include: ['journalists'] },
	});

	if (!record) {
		return <Loader />;
	}

	return (
		<div>
			{!record.id && <h3> Новая СМИ</h3>}
			<Form record={record} rootPath={rootPath}>
				<Field property="name" />
			</Form>
			{record.id && (
				<>
					<h3> Список сотрудников</h3>
					<ModelTable
						model="MediaJournalist"
						options={{ where: { mediaTitleId: +id } }}
						path={`${rootPath}/mediatitles/${id}/mediajournalists`}
						rootPath={`${rootPath}/mediatitles/${id}`}
					>
						<Column property="name" label="ФИО Журналиста" />
						<Column property="position" label="Должность" />
					</ModelTable>
				</>
			)}
		</div>
	);
};

export default MediaList;
